import { ExerciseSkill } from "./shared";
import { ExamTemplate } from "./exercises/show";

// When Rails is removed, this will replace RAILS_API in web/src/lib/constants/index.ts
export const BASE_API = '/vo/v1';

export interface SkillForExerciseCRUD {
    type: number;
    instances: number;
    position: number;
}

export interface BaseForExerciseCRUD {
    name: string;
    isExam: boolean;
    skills: SkillForExerciseCRUD[];
    spiralReviewPoints?: number;
    static?: boolean;
}

export const getSkillsForCRUD = (skills: ExerciseSkill[]): SkillForExerciseCRUD[] => {
    return skills
        .filter(skill => !skill.removed)
        .map((skill, index) => ({
            type: parseInt(skill.type),
            instances: skill.instances,
            position: index,
        }));
}

export const isExamTemplate = (obj: any): obj is ExamTemplate => {
    return obj && typeof obj === 'object' && 'type' in obj && obj.type === 'ExamTemplate';
  }